module.exports = __webpack_public_path__ + "static/media/dex-contact-labels.d03158c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/dex-contact-labels.png
// module id = 195
// module chunks = 0